import React, { ReactNode, createContext, useState, useEffect, FC } from 'react';

export const RocheXXTranslationContext = createContext<Record<string, string>>({});

interface RocheXXTranslationProviderProps {
  translationUrl: string;
  tagsTranslationUrl: string;
  popularSearchesTranslationUrl: string;
  children: ReactNode;
}

export const RocheXXTranslationProvider: FC<RocheXXTranslationProviderProps> = ({
  children,
  translationUrl,
  tagsTranslationUrl,
  popularSearchesTranslationUrl,
}) => {
  let existingTranslations = {};
  let existingTagTranslations = {};
  let existingPopularSearchTranslations = {};

  if (typeof document !== 'undefined') {
    // if in a browser environment, check for existing translations
    existingTranslations = JSON.parse(sessionStorage.getItem(translationUrl)) || {};
    existingTagTranslations = JSON.parse(sessionStorage.getItem(tagsTranslationUrl)) || {};
    existingPopularSearchTranslations = JSON.parse(sessionStorage.getItem(popularSearchesTranslationUrl)) || {};
  }
  const [translations, setTranslations] = useState<Record<string, string>>(existingTranslations);
  const [tagTranslations, setTagTranslations] = useState<Record<string, string>>(existingTagTranslations);
  const [popularSearchTranslations, setPopularSearchTranslations] = useState<Record<string, string>>(
    existingPopularSearchTranslations,
  );
  useEffect(() => {
    if (Object.keys(existingTranslations).length > 0) {
      setTranslations({ ...existingTranslations });
    } else {
      fetch(translationUrl).then((translationResponse) => {
        translationResponse.json().then((newTranslations: Record<string, string>) => {
          sessionStorage.setItem(translationUrl, JSON.stringify(newTranslations));
          setTranslations({ ...newTranslations });
        });
      });
    }
  }, [translationUrl]);
  useEffect(() => {
    if (Object.keys(existingTagTranslations).length > 0) {
      setTagTranslations({ ...existingTagTranslations });
    } else {
      fetch(tagsTranslationUrl).then((translationResponse) => {
        translationResponse.json().then((newTranslations: Record<string, string>) => {
          sessionStorage.setItem(tagsTranslationUrl, JSON.stringify(newTranslations));
          setTagTranslations({ ...newTranslations });
        });
      });
    }
  }, [tagsTranslationUrl]);
  useEffect(() => {
    if (Object.keys(existingPopularSearchTranslations).length > 0) {
      setPopularSearchTranslations({ ...existingPopularSearchTranslations });
    } else {
      fetch(popularSearchesTranslationUrl).then((translationResponse) => {
        translationResponse.json().then((newTranslations: Record<string, string>) => {
          sessionStorage.setItem(popularSearchesTranslationUrl, JSON.stringify(newTranslations));
          setPopularSearchTranslations({ ...newTranslations });
        });
      });
    }
  }, [popularSearchesTranslationUrl]);
  const combinedTranslations = { ...translations, ...tagTranslations, ...popularSearchTranslations };

  return (
    <RocheXXTranslationContext.Provider value={combinedTranslations}>{children}</RocheXXTranslationContext.Provider>
  );
};
